import { render, staticRenderFns } from "./view_proposal_pdf.vue?vue&type=template&id=6323ea39&scoped=true"
import script from "./view_proposal_pdf.vue?vue&type=script&lang=js"
export * from "./view_proposal_pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6323ea39",
  null
  
)

export default component.exports